import store from 'components/eHorizon/Typeahead/InputStore'

export default store
